import Api from 'services/Api';
import { has, get, set } from 'lodash';
import { configs, flags } from 'config';
import { addTsToPredictions } from 'utils/time';
import customEvents from 'res/assets/static/custom-events';

// eslint-disable-next-line camelcase
export const loadUser = ({ id, day }) => {
  return Api.query(
    `query($user_id: String!, $from: String!, $to: String!) {
    user(id: $user_id) {
      id
      application_id
      created_at
      device {
        os
      }
      location {
        type
        latitude
        longitude
        timestamp
      }
      locations: location_clusters {
        latitude
        longitude
        significance
        address {
          type
          country
          city
          city_type
        }
      }
      segments(status: ALPHA) {
        segment_definition_id
      }
      active_moments {
        type
        ... on CityMoment {
          type
          city_name
        }
        ... on CountryMoment {
          country_name
        }
      }
      event_history(from: $from, to: $to) {
        type
        start
        end
        start_ts
        end_ts
        ... on Stationary {
          location {
            significance
            place {
              name
              categories
            }
          }
          address {
            country
            city
          }
          latitude
          longitude
        }
        ... on Transport {
          mode
          distance
          occupant_role
          behavior_scores {
            ... on CarBehaviorScores {
              overall
            }
          }
          trajectory {
            encoded
          }
        }
      }
      moment_history(from: $from, to: $to) {
        type
        start
        end
        start_ts
        end_ts
        moment_definition_id
        moment_definition {
          display_name
        }
      }
      custom_event_history(from: $from, to: $to) {
        id
        created_at
        created_at_ts
        type
        start
        start_ts
        end
        end_ts
        source
        event_id
        latitude
        longitude
        values
      }
      prediction_tree {
        events {
          start
          end
          type
          ... on StationaryPrediction {
            location_type
          }
          ... on TransportPrediction {
            mode
          }
        }
      }
      car_behavior {
        features {
          past {
            distance
          }
          l7d {
            distance
          }
        }
        scores {
          past {
            all {
              smooth_v2
              legal_v2
              anticipative_v2
              focus
            }
          }
          l7d {
            all {
              smooth_v2
              legal_v2
              anticipative_v2
              focus
            }
          }
        }
      }
    }
  }`,
    {
      user_id: id,
      from: day,
      to: day,
    }
  ).then(res => {
    const eventsKey = 'body.data.app.user.prediction_tree.events';

    // Add start_ts and end_ts to prediction_tree
    set(res, eventsKey, addTsToPredictions(get(res, eventsKey) || []));

    if (id === '569cba20858ed3f778000004' && configs().ENV === 'preprod') {
      res.body.data.user.custom_event_history = customEvents;
    }

    return res;
  });
};

export const loadDay = ({ id, day }) => {
  return Api.query(
    `query($user_id: String!, $from: String!, $to: String!) {
    user(id: $user_id) {
      event_history(from: $from, to: $to) {
        type
        start
        end
        start_ts
        end_ts
        ... on Stationary {
          location {
            significance
            place {
              name
              categories
            }
          }
          address {
            country
            city
          }
          latitude
          longitude
        }
        ... on Transport {
          mode
          distance
          occupant_role
          behavior_scores {
            ... on CarBehaviorScores {
              overall
            }
          }
          trajectory {
            encoded
          }
        }
      }
      moment_history(from: $from, to: $to) {
        type
        start
        end
        start_ts
        end_ts
        moment_definition_id
        moment_definition {
          display_name
        }
      }
      custom_event_history(from: $from, to: $to) {
        id
        created_at
        created_at_ts
        type
        start
        start_ts
        end
        end_ts
        source
        event_id
        latitude
        longitude
        values
      }
    }
  }`,
    {
      user_id: id,
      from: day,
      to: day,
    }
  ).then(res => {
    if (id === '569cba20858ed3f778000004' && configs().ENV === 'preprod') {
      res.body.data.user.custom_event_history = customEvents;
    }

    return res;
  });
};
